import React, { useState } from "react";
import { Formik, Field, Form } from "formik";
import Loading from "../Loading";
import {
    InputGroup,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    CardWrapper,
    SelectionCard,
    FieldWrappers,
    ModalHeading,
    ModalSubHeading,
    Note,
    RupeeIcon
} from "../Styles/InputStyles";
import { toast } from "react-toastify";
import { MenuItem, Select } from "@mui/material";
import { MdOutlineInfo } from "react-icons/md";
import * as Yup from "yup";
import { gracePeriod } from "../../helpers";

const InitialSettlement = ({ propId, addRentLoading, addRentMutate, onClose }) => {
    const initialValues = {
        rentalCycle: "01",
        gracePeriod: 5,
        fine: 2,
        fineAmount: "",
        fineType: "",
    };

    const rentalCycle = [
        { label: "1st to 1st", value: "01" },
        { label: "15th to 15th", value: "15" },
        { label: "Move-In Date", value: "00" },
    ];

    const fine = [
        { label: "Yes", value: 1 },
        { label: "No", value: 2 },
    ];

    const fineType = [
        { label: "One Time", value: 1 },
        { label: "Daily", value: 2 },
    ];

    const handleSubmit = (values) => {
        const amountDepositRegex = /^\d{1,4}$/;
        const maxAmountDeposit = 10000;

        if (!values.gracePeriod || !values.fine || !values.rentalCycle) {
            toast.error("All fields are required");
            return;
        }

        if (!values.rentalCycle) {
            toast.error("Rental Cycle is required");
            return;
        }

        if (values.fine === 1) {
            if (!values.fineAmount) {
                toast.error("Fine amount is required");
                return;
            }
            if (values.fineAmount <= 0) {
                toast.error("Fine amount must be positive");
                return;
            }
            if (!amountDepositRegex.test(values.fineAmount) || parseInt(values.fineAmount) > maxAmountDeposit) {
                toast.error("Amount deposit must be between 1 and 10,000 and contain only numbers");
                return;
            }
            if (!values.fineType) {
                toast.error("Fine type is required");
                return;
            }
        }
        
        addRentMutate({
            rentalCycle: String(values.rentalCycle),
            gracePeriod: values.gracePeriod,
            fine: Number(values.fineAmount) || 0,
            fineType: values.fineType || 0,
            propId
        });
    };

    // const validationSchema = Yup.object({
    //     fineType: Yup.string().required("Please select Fine Type"),
    //     fineAmount: Yup.number().positive().required("Amount must be positive number"),
    // });

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            {({ values, setFieldValue }) => (
                <Form >
                    <ModalSubHeading>Step 3</ModalSubHeading>
                    <ModalHeading>Rent Details</ModalHeading>

                    <ScrollableContent>
                        <Wrapper>
                            <InputGroup>
                                <Label>Rental Cycle *</Label>
                                <CardWrapper>
                                    {rentalCycle.map((mode) => (
                                        <SelectionCard
                                            key={mode.value}
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setFieldValue("rentalCycle", mode.value, false);

                                            }}
                                            className={values.rentalCycle === mode.value ? "bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 text-white px-2 lg:px-4"
                                                : "bg-gray-100 text-gray-800 px-2 lg:px-4"}
                                        >
                                            <span className="text-sm">{mode.label}</span>
                                        </SelectionCard>
                                    ))}
                                </CardWrapper>
                            </InputGroup>
                            <Note className="-mt-1">
                                <MdOutlineInfo className="mt-0.5 mr-1" />
                                {values.rentalCycle === "01"
                                    ? "Rent due will be generated on the 1st of each month."
                                    : values.rentalCycle === "15"
                                        ? "Rent due will be generated on the 15th of each month."
                                        : "Rent due will be generated each month based on move-in date."}
                            </Note>

                            <InputGroup>
                                <Label>Grace Period *</Label>
                                <CardWrapper>
                                    {gracePeriod.map((mode) => (
                                        <SelectionCard
                                            key={mode.value}
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setFieldValue("gracePeriod", mode.value, false);

                                            }}
                                            className={values.gracePeriod === mode.value ? "bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 text-white"
                                                : "bg-gray-100 text-gray-800"}
                                        >
                                            <span className="text-sm">{mode.label}</span>
                                        </SelectionCard>
                                    ))}
                                </CardWrapper>
                            </InputGroup>

                            <InputGroup>
                                <Label>Fine *</Label>
                                <CardWrapper>
                                    {fine.map((mode) => (
                                        <SelectionCard
                                            key={mode.value}
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setFieldValue("fine", mode.value, false);

                                            }}
                                            className={values.fine === mode.value ? "bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 text-white"
                                                : "bg-gray-100 text-gray-800"}
                                        >
                                            <span className="text-sm">{mode.label}</span>
                                        </SelectionCard>
                                    ))}
                                </CardWrapper>
                            </InputGroup>
                            {values.fine === 1 && (
                                <>
                                    <InputGroup>
                                        <Label htmlFor="fineAmount">Fine Amount *</Label>
                                        <FieldWrappers>
                                            <RupeeIcon />
                                            <Field
                                                type="number"
                                                name="fineAmount"
                                                id="fineAmount"
                                                className='ml-5'
                                                value={values.fineAmount}
                                                onChange={(e) => setFieldValue("fineAmount", e.target.value)}
                                                required
                                            />
                                        </FieldWrappers>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label>Fine Type *</Label>
                                        <CardWrapper>
                                            {fineType.map((mode) => (
                                                <SelectionCard
                                                    key={mode.value}
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setFieldValue("fineType", mode.value);

                                                    }}
                                                    className={values.fineType === mode.value ? "bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 text-white"
                                                        : "bg-gray-100 text-gray-800"}
                                                >
                                                    <span className="text-sm">{mode.label}</span>
                                                </SelectionCard>
                                            ))}
                                        </CardWrapper>
                                    </InputGroup>
                                </>
                            )}
                        </Wrapper>
                    </ScrollableContent>
                    <ActionSection>
                        <SideCancelBtn type="button" onClick={onClose}>
                            Cancel
                        </SideCancelBtn>
                        <SubmitBtn type="submit" disabled={addRentLoading}>
                            {addRentLoading ? "Submitting..." : "Submit"}
                        </SubmitBtn>
                    </ActionSection>


                </Form>
            )}
        </Formik>
    );
};

export default InitialSettlement;